import Vue from 'vue'
import Router from 'vue-router'
import home from '../views/home'
import one from '../views/one'
import two from '../views/two'
import introduce from '../views/introduce'
import join from '../views/join'
import news from '../views/news'
import newOne from '../views/newChild/newOne'
import newTwo from '../views/newChild/newTwo'
import newThree from '../views/newChild/newThree'
import newFour from '../views/newChild/newFour'
import newFive from '../views/newChild/newFive'
import newSix from '../views/newChild/newSix'
import newSeven from '../views/newChild/newSeven'
import about from '../views/about'
Vue.use(Router);
export default new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/one',
      name: 'one',
      component: one
    },
    {
      path: '/two',
      name: 'two',
      component: two
    },
    {
      path: '/introduce',
      name: 'introduce',
      component: introduce
    },
    {
      path: '/join',
      name: 'join',
      component: join
    },
    {
      path: '/news',
      name: 'news',
      component: news,
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/newOne',
      name: 'newOne',
      component: newOne
    },
    {
      path: '/newTwo',
      name: 'newTwo',
      component: newTwo
    },
    {
      path: '/newThree',
      name: 'newThree',
      component: newThree
    },
    {
      path: '/newFour',
      name: 'newFour',
      component: newFour
    },
    {
      path: '/newFive',
      name: 'newFive',
      component: newFive
    },
    {
      path: '/newSix',
      name: 'newSix',
      component: newSix
    },
    {
      path: '/newSeven',
      name: 'newSeven',
      component: newSeven
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js